import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { Lock, ShieldCheck } from 'lucide-react';
export function OfferBlock() {
  return <section id="offer" className="py-24 px-6 bg-dark relative overflow-hidden" data-id="element-101">
      <div className="absolute inset-0 bg-radial-gold opacity-30 pointer-events-none" data-id="element-102"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="border border-gold/30 bg-darker/90 p-8 md:p-12 rounded-sm shadow-[0_0_50px_rgba(201,168,76,0.1)]" data-id="element-104">
          <div className="flex flex-col md:flex-row items-center gap-10" data-id="element-105">
            <div className="w-full md:w-1/3 flex-shrink-0" data-id="element-106">
              <img src="https://cdn.magicpatterns.com/uploads/2VEPEM7bP6opERRQagfvkU/Magnetismo_FemeninoPortada.jpg" alt="Magnetismo Femenino" className="w-full max-w-[250px] mx-auto rounded-md shadow-2xl shadow-gold/20 border border-gold/20" data-id="element-107" />
            </div>

            <div className="w-full md:w-2/3 text-center md:text-left flex flex-col items-center md:items-start" data-id="element-108">
              <h2 className="font-serif text-2xl md:text-3xl text-cream mb-4" data-id="element-109">
                Obtén el sistema completo <br data-id="element-110" />
                <span className="text-gold italic" data-id="element-111">
                  Magnetismo Femenino: El Código de la Mujer de Élite
                </span>{' '}
                hoy mismo.
              </h2>

              <p className="font-sans text-cream/80 font-light mb-8" data-id="element-112">
                No es un gasto en un libro, es una inversión en la forma en que
                el mundo te percibe para siempre.
              </p>

              <div className="mb-8" data-id="element-113">
                <p className="text-sm text-cream/60 uppercase tracking-widest mb-2" data-id="element-114">
                  Precio Especial de Lanzamiento
                </p>
                <p className="font-serif text-5xl text-gold font-bold" data-id="element-115">
                  $19.00{' '}
                  <span className="text-2xl text-gold/70 font-normal" data-id="element-116">USD</span>
                </p>
              </div>

              <CTAButton className="w-full md:w-auto mb-4" href="https://omnilectura.com/cart/48178912002273:1" data-id="element-117" />

              <div className="flex items-center gap-2 text-xs text-cream/50 font-sans tracking-wide" data-id="element-118">
                <Lock className="w-3 h-3" data-id="element-119" />
                <span data-id="element-120">
                  Acceso instantáneo tras la compra. Pago seguro y discreto.
                </span>
              </div>

              <div className="mt-6 flex items-center gap-3 border border-gold/20 rounded-sm px-5 py-3 bg-dark/50" data-id="element-121">
                <ShieldCheck className="w-8 h-8 text-gold flex-shrink-0" data-id="element-122" />
                <div data-id="element-123">
                  <p className="font-serif text-sm text-gold font-medium" data-id="element-124">
                    Garantía de 30 Días
                  </p>
                  <p className="font-sans text-xs text-cream/60 font-light" data-id="element-125">
                    Si no ves resultados, te devolvemos tu dinero. Sin
                    preguntas.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}